import { createDecorator } from '../../instantiation/common/instantiation.js';
const IWorkspacesService = ( createDecorator('workspacesService'));
export { IWorkspacesService };
